import { modalRoute } from '@/router/helpers/modalRoute'

export const reportRoutes = [
  {
    path: 'reports',
    name: 'Reports',
    component: () => import('@/components/reports/List.vue'),
    children: [
      modalRoute(
        'view/:reportId',
        'ReportDetails',
        () => import('@/components/reports/modals/ReportDetails.vue'),
      ),
      modalRoute(
        'view/:reportId/delete',
        'ReportDelete',
        () => import('@/components/reports/modals/ReportDelete.vue'),
        {
          alias: 'delete/:reportId',
        },
      ),
      modalRoute(
        'create',
        'CreateReport',
        () => import('@/components/reports/modals/Create.vue'),
      ),
    ],
  },
]
